import { Action, RequestStatus, UseCaseStateGenerator } from '@lib/plugin-redux-core';
import {
  AssignmentConfigurations,
  CREATE_EXAMINATION_ASSIGNMENT_USE_CASE,
  CREATE_HOMEWORK_ASSIGNMENT_USE_CASE,
  CREATE_PRACTICE_ASSIGNMENT_USE_CASE,
  ExaminationAssignment,
  GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE,
  GET_SECURITY_OPTIONS_USE_CASE,
  HomeworkAssignment,
  PracticeAssignment,
  SecurityOption,
} from '@module/assignment';
import {
  AssignmentCreationPageState,
  AssignmentCreationUseCaseState,
  GetAssignmentConfigurationUseCaseState,
  GetSecurityOptionsUseCaseState,
} from './assignment-creation.state';

export const handleCreatePracticeAssignmentUseCase: UseCaseStateGenerator<AssignmentCreationUseCaseState> =
  {
    name: CREATE_PRACTICE_ASSIGNMENT_USE_CASE,
    executing: (state: AssignmentCreationPageState): AssignmentCreationPageState => {
      return {
        ...state,
        assignmentCreationStatus: RequestStatus.EXECUTE,
      };
    },
    success: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { payload } = action;
      return {
        ...state,
        assignmentCreationStatus: RequestStatus.SUCCESS,
        assignmentCreationResponse: payload as PracticeAssignment,
      };
    },
    error: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { error } = action;
      return {
        ...state,
        assignmentCreationStatus: RequestStatus.ERROR,
        error: error,
      };
    },
    reset: (state: AssignmentCreationPageState): AssignmentCreationPageState => {
      return {
        ...state,
        assignmentCreationStatus: RequestStatus.RESET,
      };
    },
  };

export const handleCreateExaminationAssignmentUseCase: UseCaseStateGenerator<AssignmentCreationUseCaseState> =
  {
    name: CREATE_EXAMINATION_ASSIGNMENT_USE_CASE,
    executing: (state: AssignmentCreationPageState): AssignmentCreationPageState => {
      return {
        ...state,
        assignmentCreationStatus: RequestStatus.EXECUTE,
      };
    },
    success: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { payload } = action;

      return {
        ...state,
        assignmentCreationResponse: payload as ExaminationAssignment,
        assignmentCreationStatus: RequestStatus.SUCCESS,
      };
    },
    error: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { error } = action;
      return {
        ...state,
        assignmentCreationStatus: RequestStatus.ERROR,
        error: error,
      };
    },
    reset: (state: AssignmentCreationPageState): AssignmentCreationPageState => {
      return {
        ...state,
        assignmentCreationStatus: RequestStatus.RESET,
      };
    },
  };

export const handleGetAssignmentConfigurationsUseCase: UseCaseStateGenerator<GetAssignmentConfigurationUseCaseState> =
  {
    name: GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE,
    executing: (state: AssignmentCreationPageState): AssignmentCreationPageState => {
      return { ...state, isLoadingAssignmentDataConfigs: true };
    },
    success: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { payload } = action;
      const assignmentDataConfigs = payload as AssignmentConfigurations;
      return {
        ...state,
        assignmentConfigsResponse: assignmentDataConfigs,
        isLoadingAssignmentDataConfigs: false,
      };
    },
    error: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { error } = action;
      return { ...state, error: error, isLoadingAssignmentDataConfigs: false };
    },
  };

export const handleGetSecurityOptionsUseCase: UseCaseStateGenerator<GetSecurityOptionsUseCaseState> =
  {
    name: GET_SECURITY_OPTIONS_USE_CASE,
    executing: (state: AssignmentCreationPageState): AssignmentCreationPageState => {
      return {
        ...state,
        getSecurityOptionsStatus: RequestStatus.EXECUTE,
      };
    },
    success: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { payload } = action;

      return {
        ...state,
        securityOptions: payload as SecurityOption[],
        getSecurityOptionsStatus: RequestStatus.SUCCESS,
      };
    },
    error: (state: AssignmentCreationPageState, action: Action): AssignmentCreationPageState => {
      const { error } = action;
      return {
        ...state,
        getSecurityOptionsStatus: RequestStatus.ERROR,
        error: error,
      };
    },
    reset: (state: AssignmentCreationPageState): AssignmentCreationPageState => {
      return {
        ...state,
        getSecurityOptionsStatus: RequestStatus.RESET,
      };
    },
  };

export const assignmentCreationHandlers = [
  handleCreatePracticeAssignmentUseCase,
  handleCreateExaminationAssignmentUseCase,
  handleGetAssignmentConfigurationsUseCase,
  handleGetSecurityOptionsUseCase,
];
